define([
	"dojo/_base/declare",
	"csi/html",
	"csi/xml",
	"./BaseRenderer"
], function(declare,html,xml,BaseRenderer) {

	return declare(BaseRenderer, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for string showing parameters with grey background and tooltip
			var	node = ctx.getNode();
			var	lr = ctx.view.get("store").lrBase;

			if ((node.Id == xml.ATTR_NAME) && (node.Resources.Base == lr.getTypeName(node.Type))) {
				var	key = node.Type + ".Name";

				html.create("span", {
					"class": "csi-bg-changed",
					innerText: lr.getParameterResource(key),
					title: lr.getParameterDescription(key)
				}, refNode);

				return true;
			}

			return this.inherited(arguments);
		}
	});
});